import {Language, translations} from "../../translations";

type Props = {
    error: string;
    errorCode?: string | null;
    lang?: Language;
};

const getLoginUrl = () => {
    if (typeof window === 'undefined') {
        return '/login/';
    }
    const next = window.location.pathname + window.location.search + window.location.hash;
    return `/login/?next=${encodeURIComponent(next)}`;
};

const GameError = ({error, errorCode, lang = 'fi'}: Props) => {
    const LANG = translations[lang];

    return (
        <div className='game-error fs-2 text-center p-1 p-sm-2'>
            <div dangerouslySetInnerHTML={{__html: error}}>
            </div>
            {errorCode === 'login_required' && (
                <a href={getLoginUrl()} className='btn game-btn mt-4'>{LANG.login}</a>
            )}
        </div>
    );
}

export default GameError;
